import restfulBase from '@/services/negotiations/core/base';

const apiService = restfulBase('brokers');

export default apiService;
